import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mt-warning',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './warning.ui-component.html',
  styleUrl: './warning.ui-component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WarningUiComponent {}
